import { Route } from '@solidjs/router'
import { Show, createSignal, onMount } from 'solid-js'
import { useAuth } from './lib/auth'
import Home from './routes/Home'
import Signup from './routes/Signup'
import Pass from './routes/Pass'
import History from './routes/History'
import Staff from './routes/Staff'
import VenueLogin from './routes/VenueLogin'
import VenueDashboard from './routes/VenueDashboard'
import Invite from './routes/Invite'
import Transfer from './routes/Transfer'
import ModeSwitcher from './components/ModeSwitcher'

function isVenueDomain(): boolean {
  if (typeof window === 'undefined') return false
  return window.location.hostname === 'venue.zipcheck.my'
}

export default function App() {
  const auth = useAuth()
  const [isVenue, setIsVenue] = createSignal(false)

  onMount(() => {
    setIsVenue(isVenueDomain())
  })

  return (
    <>
      {/* Mode switcher — only shown on app.zipcheck.my to users with both roles */}
      <Show when={auth.isAuthenticated() && auth.hasStaffRole() && !isVenue()}>
        <ModeSwitcher />
      </Show>

      {/* Routes — must be direct children of Router (no wrapper div) */}
      <Route path="/" component={Home} />
      <Route path="/signup" component={Signup} />
      <Route path="/pass" component={Pass} />
      <Route path="/history" component={History} />
      <Route path="/staff" component={Staff} />
      <Route path="/invite" component={Invite} />
      <Route path="/transfer" component={Transfer} />

      {/* Venue routes */}
      <Route path="/venue-login" component={VenueLogin} />
      <Route path="/venue/:venueId" component={VenueDashboard} />
      <Route path="/venue" component={VenueDashboard} />
    </>
  )
}
